import {
  CLAIM_CREDIT,
  DEPOSIT,
  GIFTSTORE_REDEEM,
  USER_DETAILS,
  USER_SIGN_IN,
  USER_WITHDRAWAL
} from '../constants/apiTypes';
import { getCurrentUser, userSignOut } from '../actions/userActions';
import { USER_POLL_DURATION } from '../constants/pollDurations';
import {
  API_CALL_FAILURE,
  API_CALL_SUCCESS,
  PAYPAL_DEPOSIT_SUCCESS,
  SUBMIT_CHALLENGE_SUCCESS,
  SUBMIT_MULTIPLE_SUCCESS,
  SUBMIT_MULTIPLE_LINEUP_ENTRY_SUCCESS
} from '../constants/actionTypes';

function userMiddleware() {
  const apiTypes = [CLAIM_CREDIT, DEPOSIT, GIFTSTORE_REDEEM, USER_WITHDRAWAL];
  const actionTypes = [
    PAYPAL_DEPOSIT_SUCCESS,
    SUBMIT_MULTIPLE_SUCCESS,
    SUBMIT_CHALLENGE_SUCCESS,
    SUBMIT_MULTIPLE_LINEUP_ENTRY_SUCCESS
  ];
  let timerId = null;

  return ({ getState, dispatch }) => next => action => {
    if (action.type === API_CALL_FAILURE && action.status === 401) {
      const { user } = getState();

      if (user && user.isSignedIn) {
        dispatch(userSignOut());
      }
    }

    if (
      actionTypes.includes(action.type) ||
      (action.type === API_CALL_SUCCESS && apiTypes.includes(action.api))
    ) {
      clearTimeout(timerId);
      dispatch(getCurrentUser());
    } else if (
      action.type === API_CALL_SUCCESS &&
      (action.api === USER_DETAILS || action.api === USER_SIGN_IN)
    ) {
      clearTimeout(timerId);
      timerId = setTimeout(() => {
        dispatch(getCurrentUser());
      }, USER_POLL_DURATION);
    }

    return next(action);
  };
}

export default userMiddleware;
